module.exports = __webpack_public_path__ + "static/1-8506c35564f6bd7b2155456c67d8948a.jpg";